import {
  IonBadge,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonItemGroup,
    IonLabel,
    IonList,
    IonModal,
    IonTitle,
    IonToolbar
} from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { personOutline, closeCircle} from 'ionicons/icons';
import { modalController } from '@ionic/core';
import './ApprovalChainModal.css';
import ServerService from '../services/Server';
//import { Environment } from "../data/Environment";

const server = new ServerService();

interface ApprovalChainModalProps {
    id:any;
    isOpen: any;
    onDismiss:any;
}

const ApprovalChainModal: React.FC<ApprovalChainModalProps> = ({id,isOpen,onDismiss}) => {

  const [open, setOpen] = useState(false)
  const [items, setItems] = useState([])
  const [curs, setCurs] = useState([])

  const fetchItems = () => {
    
    const data = {id:id,lang:""}
    fetch(server.getFullUrl("memo/wf/assignee/list", data),
        server.getRequest()
      ).then(
      response => response.json() // if the response is a JSON object
    ).then(res => {
      if (res.success) {
        console.log("success")
        setItems(res.data)
      } else {
        console.log("!success:"+res.message);
  
        if (res.message.startsWith("|BG_ERR|")) {
          //setErrMsg(res.message.substring("|BG_ERR|".length));
        } else {
          //setErrMsg(res.message);
        }
  
        //setError(true);
      }
    }).catch(
      error => {
        console.log(error) // Handle the error response object
      }
    )
  }

  const fetchCurs = () => {
    
    const data = {id:id,lang:""}
    fetch(server.getFullUrl("memo/wf/task/list", data),
        server.getRequest()
      ).then(
      response => response.json() // if the response is a JSON object
    ).then(res => {
      if (res.success) {
        console.log("success")
        setCurs(res.data)
      } else {
        console.log("!success:"+res.message);
  
        if (res.message.startsWith("|BG_ERR|")) {
          //setErrMsg(res.message.substring("|BG_ERR|".length));
        } else {
          //setErrMsg(res.message);
        }
  
        //setError(true);
      }
    }).catch(
      error => {
        console.log(error) // Handle the error response object
      }
    )
  }

  useEffect(() => {
      if (open !== isOpen) {
        setOpen(isOpen)
        if (isOpen) {
          setItems([])
          fetchItems()
          setCurs([])
          fetchCurs()
        }
      }
  }, [isOpen])

  return (
    <IonModal
        className="my-custom-class"
        isOpen={open}
        //swipeToClose={true}
        onDidDismiss={() => {
            onDismiss();
        }}
      >
        <IonHeader>
            <IonToolbar>
                <IonButtons slot="end">
                <IonButton onClick={async () => {await modalController.dismiss()}}>
                    <IonIcon slot="icon-only" icon={closeCircle}/>
                </IonButton>
                </IonButtons>
                <IonTitle>{id} : Approval Chain</IonTitle>
            </IonToolbar>
        </IonHeader>

        <IonContent>
          <IonList>
              <IonItem color="light">
                <IonLabel color="dark"><b>Current Task</b></IonLabel>
              </IonItem>
              {curs?.map((item,i) => {
                  return (
                    <IonItemGroup>
                      <IonItem key={i*3} lines="none">
                          <IonIcon size="large" icon={personOutline}/>
                          <IonBadge color="meduim">{item.assignedToDtl}</IonBadge>
                      </IonItem>
                      <IonItem key={i*3+1}>
                          <IonBadge color="primary">{item.type}</IonBadge>
                      </IonItem>
                    </IonItemGroup>
                  )
              })}
          </IonList>
          
        <IonList>
            <IonItem color="light">
              <IonLabel color="dark"><b>Approval Chain</b></IonLabel>
            </IonItem>
            {items?.map((item,i) => {
                return (
                    <IonItemGroup>
                      <IonItem key={i*3} lines="none">
                          <IonIcon size="large" icon={personOutline}/>
                          <IonLabel className="ion-text-wrap">{item.user}</IonLabel>
                          <IonLabel className="ion-text-wrap">{item.group}</IonLabel>
                      </IonItem>
                      <IonItem key={i*3+1}>
                          <IonBadge color="primary">{item.assignee}</IonBadge>
                      </IonItem>
                    </IonItemGroup>
                )
            })}
        </IonList>
        </IonContent>
    </IonModal>
  )
        
};

export default ApprovalChainModal;
